<template>
    <div class="group">
        <div class="w-full p-16">
            <div class="flex items-start">
                <img :src="target.user.avatar || `/images/placeholders/avatar.png`" :alt="target.user.full_name" class="w-40 h-40 mr-8 rounded-full border border-blue-light">
                <div class="w-5/12">
                    <h4 class="font-bold text-16">{{ label }}</h4>
                    <span>Assigned by {{ target.user.full_name }}</span>
                    <a v-if="canDelete" @click="onDelete" class="flex text-coral mr-10 items-center cursor-pointer">
                        <svg class="w-14 h-14 fill-coral mr-4 -mt-2" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M704 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm-544-992h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"/></svg>
                        <span>Delete</span>
                    </a>
                </div>
                <div class="w-5/12 ml-auto">
                    <h4 class="font-bold text-16">{{ target.end_value }}</h4>
                    <span v-if="isConstant">per month</span>
                    <span v-if="!isConstant">{{ endAtLabel }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { format, parseISO } from 'date-fns'
    import { get } from 'vuex-pathify'

    export default {
        props: {
            canDelete: {
                type: Boolean,
                default: false
            },

            label: {
                type: String,
                required: true
            },

            target: {
                type: Object,
                required: true
            },
        },

        computed: {
            user: get('auth/user'),

            client() {
                return this.target.user.default_client
            },

            endAtLabel() {
                return format(parseISO(this.target.end_at), "'by' MMMM yyyy")
            },

            isConstant() {
                return this.target.type === 'constant'
            },
        },

        methods: {
            onDelete() {
                this.$emit('delete', this.target)
            },
        }
    }
</script>
